module.exports = __webpack_public_path__ + "img/other_charge_logo.25c249ff.png";